import { useRef, useState, useEffect } from 'react'
import { MultiViewCalendar } from '@progress/kendo-react-dateinputs'
import { Popup } from '@progress/kendo-react-popup'
import { SvgIcon } from '@progress/kendo-react-common'
import * as svgIcon from '@progress/kendo-svg-icons'
import moment from 'moment'
import './rangePickerHL.css'

/**
 * @description Selector de rango de fechas en un solo input. Muestra "inicio – fin" y
 * al hacer click abre un MultiViewCalendar en modo rango.
 * @param {{ value: {start: Date|null, end: Date|null}, onChange: Function, placeholder: String }} props
 */
const RangeDatePickerHL = ({ value, onChange, placeholder = '' }) => {
  const anchor = useRef(null)
  const popupRef = useRef(null)
  const [show, setShow] = useState(false)

  const start = value?.start || null
  const end = value?.end || null

  useEffect(() => {
    const handleOutside = (event) => {
      if (
        anchor.current && !anchor.current.contains(event.target) &&
        popupRef.current && !popupRef.current.contains(event.target)
      ) {
        setShow(false)
      }
    }
    document.addEventListener('mousedown', handleOutside)
    return () => document.removeEventListener('mousedown', handleOutside)
  }, [])

  const displayText = () => {
    if (!start && !end) return placeholder
    const formattedStart = start ? moment(start).format('DD/MM/YYYY') : '…'
    const formattedEnd = end ? moment(end).format('DD/MM/YYYY') : '…'
    return `${formattedStart} – ${formattedEnd}`
  }

  const handleCalendarChange = (event) => {
    const range = event.value
    onChange(range)
    if (range?.start && range?.end) {
      setShow(false)
    }
  }

  const hasValue = Boolean(start || end)

  return (
    <>
      <div
        className="range-picker-input"
        ref={anchor}
        onClick={() => setShow(prev => !prev)}
      >
        <span className={hasValue ? '' : 'range-picker-placeholder'}>{displayText()}</span>
        <SvgIcon icon={svgIcon['calendarIcon']} />
      </div>
      <Popup anchor={anchor.current} show={show} popupClass="range-picker-popup">
        <div ref={popupRef}>
          <MultiViewCalendar
            mode="range"
            value={{ start, end }}
            onChange={handleCalendarChange}
          />
        </div>
      </Popup>
    </>
  )
}

export { RangeDatePickerHL as default }
